<template>
  <div class="number-in-con">
    <VpInput
      :label="field.is_mandatory && !field.is_optional ? field.name : field.name + ` ${$t('common.optionalWithBrackets')}`"
      :maxlength="maxLength"
      type="number"
      width="416"
      v-model="numModel.value"
      :hideNumberFieldArrows="false"
      @input="handleMaxLength"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    field: {},
  },
  data() {
    return {
      maxLength: "20",
      numModel: null,
    };
  },
  beforeMount() {
    this.numModel = cloneDeep(this.field);
  },
  watch: {
    "numModel.value"(newVal, oldVal) {
      this.$nextTick(() => {
        if (this.numModel.value?.length > this.maxLength)
          this.numModel.value = oldVal;
      });
    },
  },
  methods: {
    handleMaxLength() {
      this.$emit("updateNum", this.numModel);
    },
  },
};
</script>
<style lang="scss">
.number-in-con {
  width: 416px !important;
  .md-field.md-theme-default .md-input {
    padding-inline-end: 18px;
  }
  .md-field.md-theme-default.md-inline {
    width: 416px !important;
  }
}
</style>
